import { Navigate } from 'react-router-dom'

export const InterviewSchoolSwitchView = () => {
  return <Navigate to="/interview-preparation/start" replace={true} />
}
